// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap';

videojs('my-player', {
    controls: true,
    autoplay: false,
    preload: 'auto'
  });